import { apiInstance, apiResponse, getLoadingState, ApiError } from '../../Api';
import { EncontroPresencial, MensagemModel, OrientacaoModel, PagedRequestAttributes } from './Model';

export const sendMessageAPI = async (mensagem: {
  enviarEmail?: boolean,
  texto?: string,
  anexo?: File,
  aluno?: number
}): Promise<apiResponse<ApiError[]>> => {
  try {
    const formData = new FormData();
    if (mensagem.anexo) formData.append('arquivo', mensagem.anexo);
    if (mensagem.aluno) formData.append('alunoId', mensagem.aluno + '');
    if (mensagem.texto) formData.append('mensagem', mensagem.texto);
    formData.append('enviarEmail', mensagem.enviarEmail ? 'true' : 'false');


    const fetchResponse = await apiInstance.post(mensagem.aluno ? '/professor/mensagem' : '/aluno/mensagem',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

    return {
      data: [],
      status: getLoadingState(fetchResponse.status)
    };

  } catch (e) {
    const status = e.response ? e.response.status : 500;
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const sendRegistroEncontroPresencialAPI = async (encontro: EncontroPresencial): Promise<apiResponse<ApiError[]>> => {
  try {
    const fetchResponse = await apiInstance.post('/professor/mensagem/reuniao', encontro);

    return {
      data: [],
      status: getLoadingState(fetchResponse.status)
    };

  } catch (e) {
    const status = e.response ? e.response.status : 500;
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const fetchMessages = async (
  page: PagedRequestAttributes,
  perfil: 'aluno' | 'professor',
  alunoId?: number
): Promise<apiResponse<MensagemModel[]>> => {
  try {
    const fetchResponse = await apiInstance.get<MensagemModel[]>(
      perfil == 'aluno' ? `/${perfil}/mensagem` : `/${perfil}/mensagem/${alunoId}`,
      { params: { ...page } }
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<MensagemModel[]>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<MensagemModel[]>;
  }
};

export const fetchOrientacoes = async (
  page: PagedRequestAttributes
): Promise<apiResponse<OrientacaoModel[]>> => {
  try {
    const fetchResponse = await apiInstance.get<OrientacaoModel[]>(
      '/professor/mensagem/aluno',
      {
        params: { ...page }
      }
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<OrientacaoModel[]>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<OrientacaoModel[]>;
  }
};

export const fetchFile = async (anexoId: string): Promise<apiResponse<Blob>> => {
  try {
    const response = await apiInstance.get<Blob>(`/arquivo/mensagem/${anexoId}`, { responseType: 'blob' })

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<Blob>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: {},
      status: getLoadingState(status)
    } as apiResponse<Blob>;
  }
};